import { Directive, inject, Signal, signal } from '@angular/core';
import { BaseComponent } from './base.component';
import { BehaviorSubject, debounceTime, fromEvent, map } from 'rxjs';
import { HelperService } from 'utils/helper';

type TemplateUtils = {
  isMobileNotIpad: boolean;
  isMobileIpad: boolean;
  isMobile: boolean;
  isMobileOrIpad: boolean;
};

@Directive()
export class BasePlusComponent extends BaseComponent {
  private helperService = inject(HelperService);

  isMobileNotIpad: () => boolean = this.helperService.isMobileNotIpad;
  isMobileIpad: () => boolean = this.helperService.isMobileIpad;
  isMobile: () => boolean = this.helperService.isMobile;
  isMobileOrIpad: () => boolean = this.helperService.isMobileOrIpad;
  isSafari: boolean = this.helperService.isSafari();
  isMobileSafari: boolean = this.helperService.isMobileSafari();
  isCustomSmallScreen: (width: number) => boolean = this.helperService.isCustomSmallScreen;

  templateUtils$: BehaviorSubject<TemplateUtils>;
  templateUtilsSignal: Signal<TemplateUtils>;

  constructor() {
    super();
    this.isPlatformBrowser = this.helperService.isPlatformBrowser;
    this.isPlatformServer = this.helperService.isPlatformServer;

    const initialUtils: TemplateUtils = {
      isMobileNotIpad: this.isMobileNotIpad(),
      isMobileIpad: this.isMobileIpad(),
      isMobile: this.isMobile(),
      isMobileOrIpad: this.isMobileOrIpad(),
    };

    this.templateUtils$ = new BehaviorSubject<TemplateUtils>(initialUtils);
    this.templateUtilsSignal = signal<TemplateUtils>(initialUtils);

    this.subscriptions.push(
      fromEvent(this.helperService.win, 'resize', { passive: true })
        .pipe(
          debounceTime(50),
          map(
            (): TemplateUtils => ({
              isMobileNotIpad: this.isMobileNotIpad(),
              isMobileIpad: this.isMobileIpad(),
              isMobile: this.isMobile(),
              isMobileOrIpad: this.isMobileOrIpad(),
            }),
          ),
        )
        .subscribe(next => {
          this.templateUtils$.next(next);
          (this.templateUtilsSignal as ReturnType<typeof signal<TemplateUtils>>).set(next);
        }),
    );
  }
}
